import { createContext, useContext, useMemo, useState } from 'react';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { handleSendOptOpe, handleVerifyOtpOpe } from '../UserControlOperation';

const ForgottenContext = createContext();

export const useForgotPassword = () => useContext(ForgottenContext);

function ForgottenProvider({ children }) {
    const { setMessage } = useTemplate();
    const [showPwdField, setShowPwdField] = useState(false); // -- Show Password Update Field
    const [loadingEmail, setLoadingEmail] = useState(false); // -- Verify Email and show loading
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');
    const [formData, setFormData] = useState({});

    const valueCtx = useMemo(() => {
        const handleChange = (e) => {
            const { name, value } = e.target;
            if (name) {
                setFormData((prev) => ({ ...prev, [name]: value }));
            }
        };
        // -- Send OTP Function
        const handleSendOtp = (e) => {
            const payload = {
                role: 'admin',
                ...formData
            };

            e?.preventDefault();
            setLoadingEmail(true);
            handleSendOptOpe(payload, setIsError)
                .then(({ data }) => {
                    setFormData((prevData) => ({
                        ...prevData,
                        Secret: data.secretKey
                    }));
                    setLoadingEmail(false);
                })
                .catch((err) => {
                    setLoadingEmail(false);
                    setMessage({ type: 'error', text: err.toString(0) });
                });
        };
        // -- Verify OTP Function
        const handleVerifyOTP = (e) => {
            e?.preventDefault();
            setLoading(true);
            handleVerifyOtpOpe(formData, setIsError)
                .then(({ title }) => {
                    setMessage({ type: 'success', text: title });
                    setShowPwdField(true);
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                    setMessage({ type: 'error', text: err.toString(0) });
                });
        };

        return {
            isError,
            setIsError,
            showPwdField,
            loadingEmail,
            loading,
            // Form Data
            formData,
            setFormData,
            handleChange,
            // Send OTP Function
            handleSendOtp,
            handleVerifyOTP
        };
    }, [formData, isError, loading, loadingEmail, setMessage, showPwdField]);

    return <ForgottenContext.Provider value={valueCtx}>{children}</ForgottenContext.Provider>;
}

export default ForgottenProvider;
